import { TFuncKey } from 'react-i18next';

export type InputStatus = 'SUCCESS' | 'ERROR' | 'DISABLED' | null;

export interface ValidationResult {
  inputStatus: InputStatus;
  message?: TFuncKey;
  messageParams?: Record<string, unknown>;
}

export type ValidateFunction<T> = (value?: T) => ValidationResult;

export function getMessageColorForStatus(status?: InputStatus) {
  if (!status) return 'grey.tertiaryText';
  return {
    SUCCESS: 'green.500',
    ERROR: 'error.text',
    DISABLED: 'grey.tertiaryText',
  }[status];
}
